import api from '@/api/damage'

export default {
  state: {
    damages: []
  },
  mutations: {
    setDamages (state, value) {
      state.damages = value
    }
  },
  actions: {
    create (store, params) {
      return api.create(params)
    },
    fetch ({commit}, params) {
      return api.get(params)
        .then((res) => {
          commit('setDamages', res.data.data)
        })
    }
  },
  getters: {
    damages: (state) => state.damages
  },
  namespaced: true
}
